<template>
    <button class="otisak-logo" @click="triggerAnimate">
        <Fingerprint :size="`${size[0]}`" :color="color" ref="fingerprint" />
        <span :style="`font-size: ${size[0] / size[1]}px; color: ${color}`">TISAK</span>
    </button>
</template>

<script>
import Fingerprint from "@/components/Fingerprint";

export default {
    name: 'Logo',

    components: {
        Fingerprint
    },

    props: {
        color: {
            type: String,
            default: '#1969d2'
        },
        size: {
            type: Array,
            default: () => [34, 1.2]
        }
    },

    methods: {
        triggerAnimate() {
            this.$refs.fingerprint.animate();
            this.$emit('click');
        }
    }
}
</script>

<style lang="scss" scoped>
.otisak-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    display: -webkit-flex;
    -webkit-justify-content: center;
    -webkit-align-items: center;
    opacity: 0.92;
    transition: opacity 0.1s ease-in;

    span {
        font-family: "Roboto", sans-serif;
        font-weight: 300;
        letter-spacing: -0.8px;
        line-height: 1;
    }

    &:hover {
        opacity: 1;
    }
}
</style>
